export const dealMarketingTypes = [
    "Marketing",
    "Cross-Sale",
    "Project Manager",
    "Tender",
    "E-Commerce",
    "Marketing Cross Sale",
    "Re-Seller Partnership",
    "Portfolio Sale",
];
export const dealMarketingTypesOptions = dealMarketingTypes.map((item) => ({ label: item, value: item }));
export const statusOptions = [
    { label: "WON", value: "Won", activeVariant: "success" },
    { label: "Lost", value: "Lost", activeVariant: "neutral" },
    { label: "Cancelled", value: "Cancelled", activeVariant: "neutral" },
];
export const dealChannelTypes = [
    "Bayt",
    "Certifind",
    "Edarabia",
    "Eventbrite",
    "E-Shot",
    "Facebook Inquiry",
    "Find Courses",
    "Gulf Talent",
    "Key Stone Academic Solutions",
    "Laimoon",
    "LinkedIn",
    "Nigerian Training and Seminars",
    "Partner Academies",
    "Phone Inquiries",
    "Social Media",
    "Speedy Course",
    "Web Inquiry",
    "Website's Chat Box",
    "WhatsApp",
    "Adwords Istizada",
    "Ta3leem",
    "Instagram",
    "Courseseekers",
    "E-Commerce",
    "Web Inquiry - Program Enrollment",
    "Google Ads",
];
export const campaignTypes = [
    "Self-Paced",
    "EdTech",
    "Mentoring",
    "Departmental",
    "Private",
    "Public - Certified Programs",
    "Public - Short Courses",
    "In-house",
    "Consulting",
    "Online",
    "CH",
    "Business Trip",
    "LVT Public - Certified Programs",
    "LVT Public - Short Courses",
    "LVT In-House",
    "Webinar",
    "Franchise",
    "L&D Broker",
    "E-Learning",
    "Coaching",
    "Classroom/Online",
    "Public-ExEd",
    "Learning Journey",
    "Other",
];

export const publicTypes = [
    "Self-Paced",
    "LVT Public - Certified Programs",
    "LVT Public - Short Courses",
    "Public - Certified Programs",
    "Public - Short Courses",
    "Mentoring",
    "Departmental",
    "Private",
    "Online",
    "CH",
    "Business Trip",
    "Webinar",
    "Franchise",
    "Classroom",
    "Other",
    "L&D Broker",
    "Public-ExEd",
    "Classroom/Online",
];

export const inHouseTypes = ["In-house", "LVT In-House", "Learning Journey"];

export const inquiryTypes = ["E-Learning", "EdTech", "Consulting", "Coaching"];

// CIPD campaigns are flagged by the backend on the campaign object itself
// (isCipd: 0|1, driven by a keyword list read from backend config - no FE
// deploy needed if that list changes). Do NOT parse the campaign name/type to
// infer this; isCipd is the single source of truth.
export const isCipdCampaign = (campaign) => Boolean(Number(campaign?.isCipd));

export const campaignTypesOptions = campaignTypes.map((item) => ({ label: item, value: item }));
export const dealChannelTypesOptions = dealChannelTypes.map((item) => ({ label: item, value: item }));

export const colorArray = [
    "#081B26",
    "#384D56",
    "#6F8086",
    "#A7B2B7",
    "#286A99",
    "#3C9DCB",
    "#66B5D8",
    "#99CDE5",
    "#276A54",
    "#389D87",
    "#65B5A5",
    "#99CEC3",
    "#A24C28",
    "#D57F5A",
    "#DF9F84",
    "#EABFAD",
    "#B43636",
    "#E76969",
    "#ED8E8E",
    "#F3B4B4",
    "#7018AD",
    "#A33FE0",
    "#BA6EE8",
    "#D19EEF",
];
export const tagOptions = [
    {
        label: "Call",
        value: "Call",
    },
    {
        label: "Call Back",
        value: "Call Back",
    },
    {
        label: "Follow Up",
        value: "Follow Up",
    },
    {
        label: "Meeting",
        value: "Meeting",
    },
    {
        label: "Customer Chat",
        value: "Customer Chat",
    },
    {
        label: "Other",
        value: "Other",
    },
];

export const POPUP_CONTENTS = {
    ABOUT: "About",
    COURSES: "Campaigns",
    DEALS: "Deals",
    NEW_DEAL: "New Deal",
    NOTES: "Notes",
    NEW_TASK: "New Task",
    EDIT_TASK: "Edit Task",
    FEED: "Feed",
    TRANSFER_DEAL: "Transfer Deal",
    NOTES_ATTACHMENT: "NotesAttachment",
    PROFILE_TASKS: "Profile Tasks",
    AI_ASSISTANT: "Certified AI Native",
    /* The conversation with the CRM's assistant. Its own popup, not a tab inside CAIN: CAIN is the
       nightly LinkedIn agent, and the two only ever shared a panel because the 300px header row had
       no space for a second trigger. The orb over the panel is that trigger instead. */
    ASSISTANT: "AI Assistant",
};

export const INHOUSE_DEAL_OBJECT = {
    amount: "",
    partner: "",
    partnerUserId: "",
    partnerName: "",
    vatIncluded: "",
    paidDeal: "",
};

export const TOGGLE_OPTIONS = [
    { label: "Yes", value: "Yes", activeVariant: "success" },
    { label: "No", value: "No", activeVariant: "neutral" },
];

export const DEAL_WON = "Won";
export const DEAL_LOST = "Lost";
export const DEAL_CANCELLED = "Cancelled";

export const DEAL_STATUS_OPTIONS = [
    { label: "WON", value: DEAL_WON, activeVariant: "success" },
    { label: "Lost", value: DEAL_LOST, activeVariant: "neutral" },
    { label: "Cancelled", value: DEAL_CANCELLED, activeVariant: "neutral" },
];

export const CANCELLATION_NOTE_MAX_LENGTH = 25;

// Reasons come from the company config `dealCancellationReasons`, a JSON object keyed by the lower-cased
// deal campaign type, each holding its reason list. A type without a key falls back to `default`, and
// `noteRequired` lists the reasons that also ask for a note. No reason list is kept in code.
const normalizeCampaignType = (dealCampaignType) =>
    String(dealCampaignType || "")
        .trim()
        .toLowerCase();

const toReasonList = (value) => (Array.isArray(value) ? value.filter((item) => typeof item === "string" && item) : []);

export const EMPTY_CANCELLATION_REASONS_CONFIG = { reasonsByType: {}, defaultReasons: [], noteRequired: [] };

// Accepts the config as stored (a JSON string) or already parsed. Anything unreadable yields no reasons.
export const parseCancellationReasonsConfig = (rawConfig) => {
    let config = rawConfig;
    if (typeof rawConfig === "string") {
        try {
            config = JSON.parse(rawConfig);
        } catch (e) {
            config = null;
        }
    }
    if (!config || typeof config !== "object" || Array.isArray(config)) return EMPTY_CANCELLATION_REASONS_CONFIG;

    const { default: defaultReasons, noteRequired, ...reasonsByType } = config;
    return {
        reasonsByType: Object.keys(reasonsByType).reduce(
            (acc, type) => ({ ...acc, [normalizeCampaignType(type)]: toReasonList(reasonsByType[type]) }),
            {}
        ),
        defaultReasons: toReasonList(defaultReasons),
        noteRequired: toReasonList(noteRequired),
    };
};

export const getCancellationReasons = (config, dealCampaignType) => {
    const reasons = config?.reasonsByType?.[normalizeCampaignType(dealCampaignType)];
    return reasons?.length ? reasons : config?.defaultReasons || [];
};

export const isCancellationNoteRequired = (config, cancellationReason) =>
    Boolean(cancellationReason) && (config?.noteRequired || []).includes(cancellationReason);

export const getCancellationReasonError = (config, { dealCampaignType, cancellationReason, cancellationNote }) => {
    const reasons = getCancellationReasons(config, dealCampaignType);
    if (!reasons.length) return "No cancellation reasons are configured for this company";
    if (!cancellationReason) return "Please select a cancellation reason";
    if (!reasons.includes(cancellationReason)) {
        return "Please select a cancellation reason for this deal type";
    }
    if (isCancellationNoteRequired(config, cancellationReason)) {
        const note = String(cancellationNote || "").trim();
        if (!note) return "Please enter a cancellation note";
        if (note.length > CANCELLATION_NOTE_MAX_LENGTH) {
            return `Cancellation note must be at most ${CANCELLATION_NOTE_MAX_LENGTH} characters`;
        }
    }
    return null;
};

// Request params for a deal being saved as Cancelled. Empty for any other status, so a payload
// never carries cancellation data for a deal that is not cancelled. The date is stamped by the
// backend and is never sent. The note is sent as entered: the reason fields clear it whenever the
// picked reason does not ask for one.
export const getCancellationParams = (dealObj) => {
    const status = dealObj?.status || dealObj?.durum;
    if (status !== DEAL_CANCELLED || !dealObj?.cancellationReason) return {};
    return {
        cancellationReason: dealObj.cancellationReason,
        cancellationNote: String(dealObj.cancellationNote || "").trim(),
    };
};
